import { createAction, props } from '@ngrx/store';

import { User } from '@models/user.model';

export const UPDATE = '[User] Update';

export const update = createAction(UPDATE, props<{ user: User }>());
